export default () => ({ 
    data: {},
    error: ''
})